/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'at.tastetest.draft.list'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  drafts: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<DraftItem>((() => draftItem) as any),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** List the signed-in user's drafts, newest first. Caller is identified via the session cookie (ctx.user on the worker side). */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

type DraftItem = {
  $type?: 'at.tastetest.draft.list#draftItem'
  id: string
  text: string
  done: boolean
  createdAt: l.DatetimeString
}

export type { DraftItem }

const draftItem = /*#__PURE__*/ l.typedObject<DraftItem>(
  $nsid,
  'draftItem',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.string(),
    text: /*#__PURE__*/ l.string(),
    done: /*#__PURE__*/ l.boolean(),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { draftItem }
